<template>
  <div class="app-container-flex-col wrapper__content">
    <p class="h3">Cet outil vous permet de formuler votre projet en formation continue, d’esquisser votre parcours, et d’obtenir le bon contact pour la suite.</p>
    <p class="h3">En maximum 10 minutes</p>
    <div class="list-orientation">
      <div class="item-orientation">
        <div class="icon-temps app-accueil-icon">
          <img :src="images.clipboard" alt="">
        </div>
        <span class="item-orientation__desc">Caractérisez votre projet en formation continue (reprise d'études, validation d'acquis, ...)</span>
      </div>
      <div class="item-orientation">
        <div class="icon-pouce app-accueil-icon">
          <img :src="images.compass" alt="">
        </div>
        <span class="item-orientation__desc">Faites-vous guider pour faire le tour de la question (identifier le diplôme, interroger vos priorités, …)</span>
      </div>
      <div class="item-orientation">
        <div class="icon-enveloppe app-accueil-icon">
          <img :src="images.usercheck" alt="">
        </div>
        <span class="item-orientation__desc">Identifiez le bon interlocuteur en fonction de votre situation (statut, avancées de votre projet, …)</span>
      </div>
      <div class="item-orientation">
        <div class="icon-enveloppe app-accueil-icon">
          <img :src="images.emailcheck" alt="">
        </div>
        <span class="item-orientation__desc">Recevez par email un récapitulatif de votre démarche et des suites à donner</span>
      </div>
    </div>
    <div class="center-content">
      <router-link to="/recueilinfos" class="button-app button-primary start-button">Je prends quelques minutes</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'accueil',
  data() {
    return {
      images: {
        clipboard: require('../assets/images/clipboard.svg'),
        compass: require('../assets/images/compass.svg'),
        usercheck: require('../assets/images/user-check.svg'),
        emailcheck: require('../assets/images/email-check.svg'),
      }
    }
  }
}
</script>

<style scoped>
.start-button {
  font-weight: bold;
  text-transform: uppercase;
}

.app-container-flex-col {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.center-content {
  display: flex;
  align-items: center;
}

.button.button-primary {
  display: inline-block;
}

.list-orientation {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: .5rem auto;
}

@media (min-width: 932px) {
  .list-orientation {
    margin: 2.25rem auto;
  }
}

.item-orientation {
  width: 100%;
  box-sizing: border-box;
  padding: 1% 3%;
  margin-bottom: 1em;
  border-bottom: 1px darkgrey solid;
  font-size: 1.2rem;
  text-align: center;
}

  @media (min-width: 932px) {
  .item-orientation {
    width: 25%;
    margin-bottom: 0;
    border-bottom: 0;
    border-right: 1px darkgrey solid;
  }
}

.item-orientation__desc {
  font-size: 1.1rem
}

.app-accueil-icon {
  margin-bottom: 1rem;
}

@media (min-width: 932px) {
  .app-accueil-icon {
    margin-bottom: 2rem;
  }
}

.app-accueil-icon img {
  height: 3rem;
}

@media (min-width: 932px) {
  .app-accueil-icon img {
    height: 5rem;
  }
}

.item-orientation:last-child {
  border: none;
}
</style>